import React, { useEffect, createElement } from 'react';
import { CONFIG } from '../config';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (!CONFIG.META_PIXEL_ID || CONFIG.META_PIXEL_ID === 'PLACEHOLDER_PIXEL_ID') return;
    // Initialize the fbq stub if it doesn't exist yet
    if (!window.fbq) {
      const fbq: any = function (...args: any[]) {
        fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      // Inject the fbevents script robustly into <head> (no reliance on an existing <script> tag)
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      (document.head || document.documentElement).appendChild(script);
    }
    window.fbq('init', CONFIG.META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}